import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '../../fuse-buttons/src/buttons';
import DrawerDialog from './drawer-dialogue';
import DrawerHeader from './drawer-header';

const { forwardRef } = React;

const sidesEnum = Object.freeze({
	left: 'left',
	right: 'right',
	top: 'top',
	bottom: 'bottom',
});

const propTypes = {
	children: PropTypes.node.isRequired,
	title: PropTypes.string.isRequired,
	backCallback: PropTypes.func,
	closeCallback: PropTypes.func,
	dataTestId: PropTypes.string,
	hasBackButton: PropTypes.bool,
	promotionalArea: PropTypes.node,
	onClose: PropTypes.func,
	open: PropTypes.bool,
	stickyDrawer: PropTypes.shape({
		container: PropTypes.shape({
			className: PropTypes.string,
			dataTestId: PropTypes.string,
			open: PropTypes.bool,
			transition: PropTypes.string,
			zIndex: PropTypes.string,
		}),
		button: PropTypes.element,
	}),
	slidePosition: PropTypes.oneOf([
		sidesEnum.bottom,
		sidesEnum.top,
		sidesEnum.left,
		sidesEnum.right,
	]),
	srLabelBackButton: PropTypes.string,
	srLabelCloseButton: PropTypes.string,
	zIndex: PropTypes.string,
};

const defaultProps = {
	backCallback: () => {},
	closeCallback: () => {},
	dataTestId: null,
	hasBackButton: false,
	promotionalArea: undefined,
	onClose: () => {},
	open: false,
	stickyDrawer: {
		container: {
			className: 'fuse-drawer__sticky-drawer',
			dataTestId: 'fuse-drawer-sticky-drawer-data-testid',
			open: false,
			transition: '200ms',
			zIndex: '1',
		},
		button: <Button />,
	},
	slidePosition: sidesEnum.right,
	srLabelBackButton: undefined,
	srLabelCloseButton: undefined,
	zIndex: '1',
};

const Drawer = forwardRef(
	(
		{
			children,
			title,
			backCallback,
			closeCallback,
			dataTestId,
			hasBackButton,
			promotionalArea,
			onClose,
			open,
			stickyDrawer,
			slidePosition,
			srLabelBackButton,
			srLabelCloseButton,
			zIndex,
			...rest
		},
		ref,
	) => (
		<DrawerDialog
			title={title}
			backCallback={backCallback}
			closeCallback={closeCallback}
			dataTestId={dataTestId}
			hasBackButton={hasBackButton}
			onClose={onClose}
			open={open}
			stickyDrawer={stickyDrawer}
			promotionalArea={promotionalArea}
			ref={ref}
			slidePosition={slidePosition}
			srLabelBackButton={srLabelBackButton}
			srLabelCloseButton={srLabelCloseButton}
			zIndex={zIndex}
			{...rest} // eslint-disable-line react/jsx-props-no-spreading
		>
			{children}
		</DrawerDialog>
	),
);

Drawer.propTypes = propTypes;
Drawer.defaultProps = defaultProps;

export { Drawer, DrawerHeader, sidesEnum };
